module.exports = __webpack_public_path__ + "site/img/23.f020ffbb.jpg";